import { render, staticRenderFns } from "./assign-technicians.vue?vue&type=template&id=a80dda52"
import script from "./assign-technicians.vue?vue&type=script&lang=js"
export * from "./assign-technicians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports